import axios from '@axios'

export default {
    namespaced: true,
    state: {

    },
    getters: {},
    mutations: {

    },
    actions: {
        
        // Get Settings constant Data
        fetchActiveNotificationData(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/notification/fetch-all-notification', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        readNotification(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/notification/system-notification/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

    },
}
